<template>
  <div
    class="location"
    style="border: 1px solid lightgray;"
  >
    <div class="border-first" />
    <div style="width: 100%;">
      <table
        class="team_table"
        style="width: 100%; box-shadow: none; font-size: 13px;cursor:auto"
      >
        <thead>
          <tr>
            <th>
              {{ $t('StoreName') }}
            </th>
            <th>
              {{ $t('Location') }}
            </th>
            <th>
              {{ $t('Quantity') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
          :is-loading="isRequestLoading('totalStockGroupedByLocationSidebar')"
          :cols="6"
          :response-data="getTotalStockGroupByLocationSidebar"
        >
          <tr
            v-for="(article, index) in getTotalStockGroupByLocationSidebar"
            :key="index"
          >
            <td>{{ article.storeName }}</td>
            <td>{{ article.locationName }}</td>
            <td>{{ article.quantity }}</td>
            <!-- <td
              v-b-modal.add-quantity
              @click="callQuantity(article)"
            >
              <button
                class="button"
              >
                {{ $t('AddToOrder') }}
              </button>
            </td> -->
          </tr>
        </LoadingSpinnerTable>
      </table>
    </div>
    <AddQuantityOrder
      :article-name="articleName"
      :location-values="locationValues"
      @addQuantityToOrder="addToOrder"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import AddQuantityOrder from './modals/AddQuantityOrder.vue'

export default {
  components: {
    AddQuantityOrder,
  },
  props: ['articleName', 'articleList'],
  data() {
    return {
      location: null,
      locationValues: null,
    }
  },
  computed: {
    ...mapGetters(['getTotalStockGroupByLocationSidebar']),
  },
  watch: {
  },
  methods: {
    ...mapActions([]),
    callQuantity(value) {
      this.locationValues = value
    },
    addToOrder(value) {
      const object = {
        ...this.locationValues,
        ...this.articleName,
        quantity: value.quantity,
        productInStockId: value.productInStockId,
        discount: 0,
        currency: '$',
        pickedUpDate: moment().format('YYYY-MM-DD'),
        typeOfArticle: 'Stock article',
        valueWithVAT: this.articleName.sellPrice * value.quantity,
        valueWithoutVAT: parseFloat(((this.articleName.sellPrice / (1 + 18 / 100)) * value.quantity).toFixed(2)),
        priceWithVAT: this.articleName.sellPrice,
        priceWithoutVAT: parseFloat((this.articleName.sellPrice / (1 + 18 / 100)).toFixed(2)),
        selectedVAT: 18,
        validationPriceWithoutVAT: false,
        validationamount: false,
        validationPriceWithVAT: false,
        validationValueWithVAT: false,
        discountedPrice: this.articleName.sellPrice,
        discountType: '€',
        isCollapsed: true,
        textFromScanner: '',
        measurementType: 'Part',
        ifMeasurementTypeMeter: false,
        quantityMeter: 1,
      }
      this.$emit('addToOrder', object)
    },
  },
}
</script>

  <style scoped>
    .border-first {
    border:1px solid #EAE9EA;
    border-bottom:none;
    padding:12px;
    padding-top:50px;
  }
  .team_table td {
    padding: 10px 9px !important;
  }
  .location {
    width: 40%;
  }
  .green {
    color: green;
  }

  .red {
    color: red;
  }

  .orange {
    color: orange;
  }
  @media screen and (max-width: 1200px) {
    .location {
      width: 100%;
    }
    .border-first {
    border:1px solid #EAE9EA;
    border-bottom:none;
    padding:12px;
    padding-top:30px;
  }
  }
  </style>
